import { defineComponent } from 'vue';
import { FieldType } from '@/store/enums/hrgs/master/FormBuilderEnum';
import { validationRequired } from '@/core/helpers/validation';
import FRAPL01 from './FormCodeList/FRAPL01.vue';
import { useAbility } from '@casl/vue';
import { useRoles } from '@/core/helpers/hrgs/userRoles';
export default defineComponent({
    components: { FRAPL01 },
    props: {
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        formCode: {
            type: String,
            required: true
        },
        preview: Boolean,
        isAssessment: Boolean,
        isMyAssessment: Boolean,
        disabled: Boolean,
        formRef: Object
    },
    emits: ['update:options'],
    setup(props) {
        const { can } = useAbility();
        const { isAssessor } = useRoles();
        const widthForm = (item) => {
            switch (item.fieldType.name) {
                case FieldType.Header:
                case FieldType.Scheme:
                case FieldType.SubHeader:
                case FieldType.Table:
                case FieldType.CheckBox:
                case FieldType.RadioButton:
                    return 24;
                default:
                    return 12;
            }
        };
        const setRules = (fieldIndex) => {
            return {
                rules: [validationRequired()],
                prop: `fields.${fieldIndex}.value`
            };
        };
        const showByRoles = (item) => {
            if (item.visibleBy.length) {
                let result = false;
                item.visibleBy.forEach((item) => {
                    if (can('read', item)) {
                        result = true;
                    }
                });
                return result;
            }
            return false;
        };
        const editableByRoles = (item) => {
            if (item.editableBy.length) {
                let result = false;
                item.editableBy.forEach((item) => {
                    if (can('read', item)) {
                        result = true;
                    }
                });
                return result;
            }
            return false;
        };
        const disabledField = (item) => {
            if (item.fieldType.name === FieldType.Scheme &&
                props.formCode === 'FR.APL.02' &&
                isAssessor) {
                return !props.isMyAssessment;
            }
            return !editableByRoles(item) || props.disabled;
        };
        return {
            FieldType,
            widthForm,
            setRules,
            showByRoles,
            editableByRoles,
            disabledField
        };
    }
});
